import { LayoutList, LayoutGrid } from 'lucide-react';
import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group';
import { Label } from '@/components/atoms/texts/label';

export function ViewToggle({ value, onValueChange }) {
  return (
    <ToggleGroup
      type="single"
      value={value}
      onValueChange={(v) => v && onValueChange(v)}
      className="rounded-full border border-border p-1 h-8"
    >
      <ToggleGroupItem value="list" className="rounded-full h-full px-2 py-0 gap-firstDegree" aria-label="Vue liste">
        <LayoutList className="size-4" />
        <Label>Liste</Label>
      </ToggleGroupItem>
      <ToggleGroupItem value="grid" className="rounded-full h-full px-3 py-0 gap-firstDegree" aria-label="Vue grille">
        <LayoutGrid className="size-4" />
        <Label>Grille</Label>
      </ToggleGroupItem>
    </ToggleGroup>
  );
}
